import React from 'react';
import { BrowserRouter as Router, Route, Link, NavLink, Switch } from 'react-router-dom'
import Generate from '../helpers/generate';
import ProfileCreate from './profile.create';
import firebase from 'firebase';

class GameFooter extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			overlay: null
		}

		this.handleProfileCreate = this.handleProfileCreate.bind(this);
		this.handleProfileCreateCallback = this.handleProfileCreateCallback.bind(this);

	}


	handleProfileCreate() {
		this.setState({overlay: true})
	}

	handleProfileCreateCallback() {
		this.setState({overlay: false});
	}

	// handleGenerateProfileClick () {
	// 	this.setState({ overlay: true });
		// Generate.profile(this.props.game.id, {})
		// .then(response => {
		// 	this.setState({ complete: true });
		// })
		// .catch(error => {
		// 	this.setState({ loading: false });
		// })
	// }

	handleEndGameClick = () => {
		// console.log('handleEndGameClick', this.props.gameId);
		firebase.database().ref(`/games/${this.props.gameId}/active`).set(false)
		.then(response => {
			// console.log('game deactivated', response);
			this.setState({ complete: true });
		})
		.catch(error => {
			// console.warn('game could not deactivate', error)
		})
	}

	handleReopenGameClick = () => {
		// console.log('handleReopenGameClick', this.props.gameId);
		firebase.database().ref(`/games/${this.props.gameId}/active`).set(true)
		.then(response => {
			// console.log('game reactivated', response);
			this.setState({ complete: true });
		})
		.catch(error => {
			console.warn('game could not reactivate', error)
		})
	}

	render() {

		if(this.state.overlay) {
			return <ProfileCreate type={this.state.overlay} callback={this.handleProfileCreateCallback} game={this.props.game} gameId={this.props.gameId} />
		}

		return <footer className={this.props.userProfile && this.props.userProfile.permission === 'leader' ? '-leader' : '-participant'}>


		{/* Active Games */}
		{this.props.game.active && <span>

			<NavLink to={`/game/${this.props.gameId}/profile/${this.props.user.uid}`} className="button -primary -outline">
			My Profile
			</NavLink>

			<NavLink to={`/game/${this.props.gameId}/wallet`} className="button -primary -outline">
			People
			</NavLink>

			{this.props.userProfile && this.props.userProfile.permission === 'leader' &&  <a className="button" onClick={this.handleEndGameClick}>
			End Game
			</a>}

			<Link to={`/`} className="button -light -outline">
			Leave
			</Link>

			{this.props.userProfile && this.props.userProfile.permission === 'leader' && <a className="button -light -outline" onClick={this.handleProfileCreate}>
			Create Profile
			</a>}

			</span>}

			{/* Ended Games */}
			{!this.props.game.active && <span>

				<Link to={`/`} className="button -light -outline">
				Leave
				</Link>

				{this.props.userProfile && this.props.userProfile.permission === 'leader' && <a className="button -light -outline" onClick={this.handleReopenGameClick}>
				Reopen Game
				</a>}

				</span>}

				</footer>

			}
		}

		export default GameFooter



// WEBPACK FOOTER //
// ./src/components/game/footer.js